/**
 * なごみ工房 - UI Enhancements
 * Vanilla JS / No dependencies / IntersectionObserver based
 */
(function () {
  'use strict';

  /* ------------------------------------------------
   * 1. Scroll-reveal animations
   * ------------------------------------------------ */
  function initScrollReveal() {
    const els = document.querySelectorAll('.nagomi-reveal');
    if (!els.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('nagomi-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach((el) => observer.observe(el));
  }

  /* ------------------------------------------------
   * 2. Reviews carousel
   * ------------------------------------------------ */
  function initReviewsCarousel() {
    const track = document.querySelector('.nagomi-reviews__track');
    if (!track) return;

    const cards = track.querySelectorAll('.nagomi-reviews__card');
    if (cards.length <= 1) return;

    let current = 0;
    const total = cards.length;
    let autoTimer = null;
    let startX = 0;
    let isDragging = false;

    // Build dots
    const dotsWrap = track.parentElement.querySelector('.nagomi-reviews__dots');
    if (dotsWrap) {
      for (let i = 0; i < total; i++) {
        const dot = document.createElement('button');
        dot.className = 'nagomi-reviews__dot' + (i === 0 ? ' nagomi-reviews__dot--active' : '');
        dot.setAttribute('aria-label', 'レビュー ' + (i + 1));
        dot.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(dot);
      }
    }

    function goTo(index) {
      current = ((index % total) + total) % total;
      track.style.transform = 'translateX(-' + current * 100 + '%)';
      updateDots();
      resetAuto();
    }

    function updateDots() {
      if (!dotsWrap) return;
      const dots = dotsWrap.querySelectorAll('.nagomi-reviews__dot');
      dots.forEach((d, i) => {
        d.classList.toggle('nagomi-reviews__dot--active', i === current);
      });
    }

    function next() { goTo(current + 1); }

    function resetAuto() {
      clearInterval(autoTimer);
      autoTimer = setInterval(next, 5000);
    }

    // Touch / swipe
    track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    }, {
      
    // 20260902 修正
      passive: !0
    });                  
    const carousel = track.closest(".nagomi-reviews__carousel");
    const prevBtn = carousel.querySelector(".nagomi-reviews__prev");
    const nextBtn = carousel.querySelector(".nagomi-reviews__next");
    prevBtn && prevBtn.addEventListener("click", () => goTo(current - 1)), nextBtn && nextBtn.addEventListener("click", () => goTo(current + 1)), resetAuto()
    //   passive: true });
    // 
    // Nav arrows    
    // const prevBtn = track.parentElement.querySelector('.nagomi-reviews__prev');
    // const nextBtn = track.parentElement.querySelector('.nagomi-reviews__next');
    // if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    // if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));
    // 
    // resetAuto();
  }

  /* ------------------------------------------------
   * 3. Hero text entrance animation
   * ------------------------------------------------ */
  function initHeroAnimation() {
    const hero = document.querySelector('.nagomi-hero');
    if (!hero) return;
    // Staggered entrance — trigger via class on parent
    requestAnimationFrame(() => {
      setTimeout(() => hero.classList.add('nagomi-hero--loaded'), 150);
    });
  }

  /* ------------------------------------------------
   * 4. Smooth number count-up for trust bar (optional)
   * ------------------------------------------------ */
  function initCountUp() {
    const items = document.querySelectorAll('.nagomi-trust__text[data-count]');
    if (!items.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const target = parseInt(el.getAttribute('data-count'), 10);
          const suffix = el.getAttribute('data-suffix') || '';
          const duration = 1200;
          const start = performance.now();

          function step(now) {
            const progress = Math.min((now - start) / duration, 1);
            const ease = 1 - Math.pow(1 - progress, 3); // easeOutCubic
            el.textContent = Math.floor(target * ease).toLocaleString() + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
          observer.unobserve(el);
        });
      },
      { threshold: 0.5 }
    );

    items.forEach((el) => observer.observe(el));
  }

  /* ------------------------------------------------
   * Init on DOM ready
   * ------------------------------------------------ */
  function init() {
    initScrollReveal();
    initReviewsCarousel();
    initHeroAnimation();
    initCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
